import '@tencent/exeditor3-ui-kit/dist/toolbar-select.js';
import { defaultOption } from './data.js';
import { dropdownIcon } from './icon.js';
const isValidSize = (size) => /^(\d*\.)?\d+(px|pt|em|rem|%)$/.test(size.trim());
export class FontSizePlugin {
    constructor(opt = {}) {
        this.name = 'fontSize';
        this.get = () => this.editor.selection().getMarkAttrs(this).size;
        this.set = (size) => {
            if (size) {
                this.editor.selection().addMark(this, { size });
            }
            else {
                this.editor.selection().removeMark(this);
            }
        };
        this.clear = () => this.editor.selection().removeMark(this);
        this.canApply = () => this.editor.selection().canToggleMark(this);
        this.opt = {
            ...defaultOption,
            ...opt,
        };
        this.spec = {
            type: 'mark',
            matchStyle: {
                'font-size': (size) => (isValidSize(size) ? { size } : false),
            },
            attrs: {
                size: {
                    toDOMAttribute: (size) => size ? { style: `font-size: ${size}` } : null,
                },
            },
            toDOM: 'span',
        };
    }
    initEditor(editor) {
        this.editor = editor;
    }
    capabilities() {
        return {
            // 定义操作
            commands: {
                set: this.set,
                get: this.get,
                clear: this.clear,
            },
            // 定义快捷键
            shortcuts: {},
        };
    }
    // 自定义菜单按钮
    renderToolbarItem(ctx) {
        const t = this.editor.t.bind(this.editor);
        const select = document.createElement('exeditor-toolbar-select');
        select.label = ctx.in === 'dropdown' ? '' : t('字号');
        const textWrapper = document.createElement('span');
        textWrapper.style.paddingLeft = '5px';
        textWrapper.textContent = this.opt.default;
        const iconWrapper = document.createElement('span');
        iconWrapper.innerHTML = ctx.in === 'dropdown' ? '' : dropdownIcon;
        const wrapper = document.createElement('span');
        wrapper.append(textWrapper, iconWrapper);
        select.append(wrapper);
        this.opt.options.forEach((entry) => {
            const option = document.createElement('exeditor-toolbar-option');
            option.slot = 'option';
            option.value = entry.value;
            option.innerText = entry.label;
            option.onclick = () => {
                this.editor.focus();
                this.set(entry.value);
            };
            select.appendChild(option);
        });
        /** 对非下拉选项中的字体大小数值，格式化为两位小数
         * 例如从 wps 粘贴过来的字体大小为12.00001 pt ，这里将其格式化为12.00 pt 。
         */
        const formatSizeVal = (val) => {
            var _a;
            const parsedVal = parseFloat(val);
            const num = Number.isNaN(parsedVal) ? '' : parsedVal.toFixed(2);
            const unit = ((_a = val.match(/\.?\d+(\w+)$/)) === null || _a === void 0 ? void 0 : _a[1]) || '';
            return num === '' ? '' : `${num}${unit}`;
        };
        const valToLable = (val) => {
            var _a;
            return (((_a = this.opt.options.find((entry) => {
                return val === entry.value;
            })) === null || _a === void 0 ? void 0 : _a.label) || formatSizeVal(val));
        };
        const setBtnProps = () => {
            const size = this.get();
            select.active = Boolean(size);
            select.value = size || this.opt.default;
            textWrapper.textContent = t(valToLable(select.value));
            select.disabled = !this.canApply();
        };
        setBtnProps();
        this.editor.on('idlechange', setBtnProps);
        return select;
    }
}
//# sourceMappingURL=index.js.map